/** Colour tokens of tokens.css as data, for contrast tests and the component gallery (direction A « Atelier »). */
export const COLOR_TOKENS = [
  'bg',
  'surface',
  'surface-2',
  'overlay',
  'fg',
  'fg-muted',
  'fg-subtle',
  /** Text-only twins of fg-subtle and accent (P18): same hue, tuned to 4.5:1 on bg, chrome, surface and accent-soft; fills and borders keep the originals. */
  'fg-subtle-text',
  'border',
  'border-strong',
  'accent',
  'accent-hover',
  'accent-fg',
  'accent-soft',
  'accent-text',
  'focus',
  'danger',
  'success',
  'warning',
  /** Board paper for previews of board content (white in both themes, like the canvas and the export). */
  'paper',
  /** Floating interface surfaces (P15): bars, menus, panels, dialogs, cards; never on the board. */
  'chrome',
  'chrome-hover',
] as const;
export type ColorToken = (typeof COLOR_TOKENS)[number];
export type ThemeName = 'light' | 'dark';

export const THEMES: Record<ThemeName, Record<ColorToken, string>> = {
  light: {
    bg: '#f4f2ee',
    surface: '#ffffff',
    'surface-2': '#f7f5f1',
    overlay: '#1a18148c',
    fg: '#1a1814',
    'fg-muted': '#5f5a52',
    'fg-subtle': '#8a847a',
    'fg-subtle-text': '#6a645b',
    border: '#e4dfd6',
    'border-strong': '#8c8478',
    accent: '#d90429',
    'accent-hover': '#b80322',
    'accent-fg': '#ffffff',
    'accent-soft': '#fbe6e9',
    'accent-text': '#c10325',
    focus: '#d90429',
    danger: '#b42318',
    success: '#1f7a4d',
    warning: '#9a5a06',
    paper: '#ffffff',
    chrome: '#ffffff',
    'chrome-hover': '#f1eee8',
  },
  dark: {
    bg: '#0a0a0a',
    surface: '#161514',
    'surface-2': '#1f1e1c',
    overlay: '#000000a6',
    fg: '#f5f3ef',
    'fg-muted': '#a39e96',
    'fg-subtle': '#7a756d',
    'fg-subtle-text': '#928d85',
    border: '#2a2826',
    'border-strong': '#6b665f',
    accent: '#d90429',
    'accent-hover': '#b80322',
    'accent-fg': '#ffffff',
    'accent-soft': '#3a1218',
    'accent-text': '#ff6b81',
    focus: '#ff5a72',
    danger: '#ff7a6e',
    success: '#4cc38a',
    warning: '#f5a524',
    paper: '#ffffff',
    chrome: '#141312',
    'chrome-hover': '#24221f',
  },
};

/** The canvas stays white with dots whatever the interface theme (spec §14): chrome over it must read on white. */
export const CANVAS_WHITE = '#ffffff';
